import "./AccountPerformanceDateRangeComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {TimeFrame, TimeFrameRanges} from "../../models/TimeFrame";
import {AccountPerformanceViewStore} from "../../service/AccountPerformanceViewStore";
import {Observable, ReplaySubject} from "rxjs";

export const DateRange = "tfAccountPerformanceDateRange";

export function dateRange(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/range/AccountPerformanceDateRangeComponent.html`,
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: AccountPerformanceDateRangeComponentController
    };
}

export class AccountPerformanceDateRangeComponentController implements IOnInit, IOnDestroy {

    public readonly viewStore: AccountPerformanceViewStore;

    public timeFrame$: Observable<TimeFrame>;
    public timeFrameRanges$: Observable<TimeFrameRanges>;
    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor() {

    }

    public $onInit(): void {
        this.timeFrame$ = this.viewStore
                              .timeFrame
                              .takeUntil(this.destroyed$);

        this.timeFrameRanges$ = this.viewStore
                                    .timeFrameRanges
                                    .takeUntil(this.destroyed$);
    }

    public changeTimeFrame(timeFrame: TimeFrame) {
        this.viewStore.updateTimeFrame(timeFrame);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
